import { render, staticRenderFns } from "./SwitchLanguage.vue?vue&type=template&id=43c19c1e"
import script from "./SwitchLanguage.vue?vue&type=script&lang=js"
export * from "./SwitchLanguage.vue?vue&type=script&lang=js"
import style0 from "./SwitchLanguage.vue?vue&type=style&index=0&id=43c19c1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports